import { computed } from 'vue'

// 1. Define the props object separately so it can be imported
export const formFieldProps = {
  id: {
    type: [String, Number],
    default: null
  },
  label: {
    type: String,
    default: null
  },
  placeholder: {
    type: String,
    default: null
  },
  description: {
    type: String,
    default: null
  },
  disabled: {
    type: Boolean,
    default: false
  },
  errorMessage: {
    type: String,
    default: null
  },
  validation: {
    type: Boolean, // Note: You had default: null, but Boolean usually defaults to false
    default: null
  }
}

// 2. The Composable Logic
export function useFormField(props) {
  // 1. ID Logic
  const uid = `input-${Math.random().toString(36).substring(7)}`
  const inputId = computed(() => props.id || uid)

  // 2. Validation Logic
  // We use === because validation can be null (neutral)
  const isError = computed(() => props.validation === false)
  const isSuccess = computed(() => props.validation === true)

  // 3. Return everything needed by the template
  return {
    inputId,
    isError,
    isSuccess
  }
}
